import { initializeApp } from 'firebase/app'
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth'

const firebaseApp = initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
})

// eslint-disable-next-line import/prefer-default-export
export const firebaseAuth = getAuth(firebaseApp)

// Wait for persistence before subscribing to auth changes so a brief network issue
// cannot race restoring the locally persisted Firebase session.
export const firebaseAuthPersistenceReady = setPersistence(firebaseAuth, browserLocalPersistence).catch(error => {
  console.error('Failed to set auth persistence:', error)
})
